var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.externalMenu && _vm.externalMenu.url)?_c('div',{ref:"iframeWrapper",staticClass:"iframe-wrapper",style:(_vm.sideStyles)},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.externalMenu.url,"height":"100%","width":"100%"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }